import { c as _c } from "react/compiler-runtime";
import * as React from "react";
interface SpinnerPropsType {
  color?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
}
function Spinner(t0) {
  const $ = _c(12);
  const {
    size: t1,
    backgroundColor: t2,
    color: t3,
    className
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const backgroundColor = t2 === undefined ? "#d2d6d9" : t2;
  const color = t3 === undefined ? "#b2cd0e" : t3;
  let t4;
  if ($[0] !== backgroundColor) {
    t4 = <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill={backgroundColor} />;
    $[0] = backgroundColor;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== color) {
    t5 = <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill={color} />;
    $[2] = color;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== size || $[5] !== t4 || $[6] !== t5) {
    t6 = <svg aria-hidden="true" className="animate-spin" width={size} height={size} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">{t4}{t5}</svg>;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="sr-only">Loading...</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== className || $[10] !== t6) {
    t8 = <div role="status" className={className}>{t6}{t7}</div>;
    $[9] = className;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
export default Spinner;